/* React */
import { Component } from "react"

/* Icon component */
import Icon from "./Icon"

/* Translation */
import { translate } from "../translates"

/* Component WhenModal */
class WhenModal extends Component {

    componentDidMount = () => {
        document.addEventListener("keydown", this._onKey)
        document.body.style.overflow = "hidden"
    }

    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._onKey)
        document.body.style.overflow = ""
    }

    /* Draw On Key */
    _onKey = (event) => {
        if (event.key === "Escape") {
            this.props.onClose()
        }
    }

    /* Draw Days */
    _days = () => {
        const today = new Date()
        const dow = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"]
        const months = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"]
        return Array.from({ length: 14 }, (_, i) => {
            const date = new Date(today)
            date.setDate(today.getDate() + i)
            const label = `${translate(dow[date.getDay()])}, ${date.getDate()} ${translate(months[date.getMonth()])}`
            return { label, key: `${date.getDate()}-${date.getMonth()}` }
        })
    }

    render = () => {
        /* Fields */
        const { onClose, value, onSelect } = this.props
        const quickOptions = ["Сегодня", "Завтра", "На этой неделе", "В следующей неделе"]
        const days = this._days()

        return (
            <div className="modal-backdrop" onClick={onClose}>
                <div className="modal modal--sm" onClick={(event) => event.stopPropagation()}>
                    <div className="modal__header">
                        <h3 className="modal__title">{translate("Когда")}</h3>
                        <button className="modal__close" onClick={onClose} aria-label={translate("Закрыть")}>
                            <Icon name="close" size={20} />
                        </button>
                    </div>
                    <div className="modal__body" style={{ padding: 24 }}>
                        <div style={{ marginBottom: 18 }}>
                            <div style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
                                {translate("Быстрый выбор")}
                            </div>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8 }}>
                                {quickOptions.map((option) => (
                                    <button
                                        key={option}
                                        className="filter"
                                        style={value === option ? { background: "var(--accent)", color: "#fff", borderColor: "var(--accent)" } : {}}
                                        onClick={() => { onSelect(option); onClose() }}
                                    >
                                        {translate(option)}
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 10 }}>
                                {translate("Конкретный день")}
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                {days.map((day) => (
                                    <button
                                        key={day.key}
                                        style={{
                                            padding: "12px 14px",
                                            borderRadius: 10,
                                            textAlign: "left",
                                            fontWeight: 600,
                                            fontSize: 14,
                                            background: value === day.label ? "var(--accent)" : "transparent",
                                            color: value === day.label ? "#fff" : "var(--ink)"
                                        }}
                                        onClick={() => { onSelect(day.label); onClose() }}
                                    >
                                        {day.label}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

/* Export */
export default WhenModal
